import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { ScrollStatus, Scrollbar as ScrollbarType } from 'smooth-scrollbar/interfaces';
import { Scrollbar as SmoothScrollbar } from 'smooth-scrollbar-react';
import { gray3, gray5, gray1 } from '../../colours';

interface BorderRadiusProps {
  borderRadius?: string,
}

const ScrollbarStyleModifier = styled.div<BorderRadiusProps>`
  height: 100%;
  /* background-color:${gray1}; */
  & > div > .scrollbar-track-y {
    width: 6px;
    background-color: ${gray3};

    & > .scrollbar-thumb-y {
      width: 6px;
      background-color: ${gray5};
    }
  }

  & > :first-child {
    ${(props) => (props.borderRadius ? `border-radius: ${props.borderRadius};` : '')}
  }
`;

const HeightLimiter = styled.div`
  height: 100%;
  max-height: ${(props: Props) => props.maxHeight};
  overflow-y: scroll;
  overflow-x: hidden;
`;

interface Props {
  maxHeight: string,
  children: ReactNode
  borderRadius?: string,
  // eslint-disable-next-line no-unused-vars
  onScroll?: ((status: ScrollStatus, scrollbar: ScrollbarType | null) => void) | undefined,
}

const Scrollbar = ({
  maxHeight, children, borderRadius = '10px', onScroll,
}: Props) => (
  <ScrollbarStyleModifier borderRadius={borderRadius}>
    <SmoothScrollbar
      plugins={{ overscroll: { maxOverscroll: 30, damping: 0.15 } }}
      onScroll={onScroll}
      alwaysShowTracks
      renderByPixels
      continuousScrolling
    >
      <HeightLimiter maxHeight={maxHeight}>
        {children}
      </HeightLimiter>
    </SmoothScrollbar>
  </ScrollbarStyleModifier>
);

Scrollbar.defaultProps = {
  onScroll: undefined,
};

export default Scrollbar;
